import React, {useEffect, useState} from 'react'
import {Box, CircularProgress, Typography} from '@mui/material'
import DataTable, {ColumnDef, PaginationState} from 'src/components-new/data/DataTable'
import {STATUS} from 'src/constants/constants'
import {useAppSelector} from 'src/hooks'
import CaregiverDetailDialogNew from 'src/pages-new/patient/tabs/caregivers/CaregiverDetailDialogNew'
import {buildColumnsFromPsp, CaregiverRecord, DEFAULT_COLUMNS} from 'src/pages-new/patient/tabs/caregivers/columns'
import apiClient from 'src/services/apiClient'

interface CaregiversTabProps {
  patientId: string
}

export default function CaregiversTab({patientId}: CaregiversTabProps): JSX.Element {
  const caregiversColumnOptions: {id: string; label: string}[] | undefined = useAppSelector(
    state => state.pspConfigReducer.data.patientDetailConfiguration?.caregiversConfiguration?.columnOptions
  )

  const columns: ColumnDef<CaregiverRecord>[] = caregiversColumnOptions && caregiversColumnOptions.length > 0
    ? buildColumnsFromPsp(caregiversColumnOptions)
    : DEFAULT_COLUMNS

  const [caregivers, setCaregivers] = useState<CaregiverRecord[]>([])
  const [totalElements, setTotalElements] = useState(0)
  const [status, setStatus] = useState<string>(STATUS.PENDING)
  const [pagination, setPagination] = useState<PaginationState>({page: 0, rowsPerPage: 10})
  const [selectedCaregiver, setSelectedCaregiver] = useState<CaregiverRecord | undefined>(undefined)

  useEffect(() => {
    setStatus(STATUS.PENDING)
    Promise.all([
      apiClient.getPatientsCaregivers(patientId, setStatus, pagination),
      apiClient.getPatientsCaregiversCount(patientId, () => {})
    ])
      .then(([data, count]) => {
        setCaregivers(Array.isArray(data) ? data : [])
        setTotalElements(typeof count === 'number' ? count : 0)
      })
      .catch(() => setStatus(STATUS.REJECTED))
  }, [patientId, pagination])

  if (status === STATUS.PENDING) {
    return (
      <Box sx={{display: 'flex', justifyContent: 'center', py: 6}}>
        <CircularProgress />
      </Box>
    )
  }

  if (status === STATUS.REJECTED) {
    return (
      <Box sx={{py: 4, textAlign: 'center'}}>
        <Typography variant="body2" color="error">
          Impossibile caricare caregiver/tutori.
        </Typography>
      </Box>
    )
  }

  return (
    <>
      <DataTable
        columns={columns}
        keyField="_id"
        rows={caregivers}
        pagination={pagination}
        totalElements={totalElements}
        onPaginationChange={setPagination}
        onRowClick={setSelectedCaregiver}
        emptyMessage="Non ci sono caregiver/tutori registrati per questo paziente."
        hideMobileCardDivider
      />
      {selectedCaregiver && (
        <CaregiverDetailDialogNew
          detail={selectedCaregiver}
          open={Boolean(selectedCaregiver)}
          onClose={() => setSelectedCaregiver(undefined)}
        />
      )}
    </>
  )
}
